export default [
    {
        p_id: 1,
        p_name: "Spice express ",
        p_desc:
            "Building a great online presence is essential to the success of your restaurant. Well-designed restaurant websites are the cornerstone of this online presence and can serve to both attract new customers and build loyalty in existing customers.",
        p_tech:
            "Javascript, React, HTML, CSS, API, axios, React-router-dom, smooth-scroll",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899/spice-express-app",
        p_web: "https://crave-vars.netlify.app",
    },
    {
        p_id: 2,
        p_name: "Pacman Game",
        p_desc:
            "Pac-Man with voice control is a maze chase video game the player controls the eponymous character through an enclosed maze. The objective of the game is to eat all of the dots placed in the maze while avoiding four colored ghosts",
        p_tech: "Javascript, HTML, CSS, API, ALAN AI",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899/pacman",
        p_web: "https://pacman-vars.netlify.app",
    },
    {
        p_id: 3,
        p_name: "Portfolio",
        p_desc:
            "The importance of having a professional online presence is more important than ever, and an online portfolio will certainly increase your visibility and presence. Creating your portfolio website allows you to share and showcase your work easily with the employers you’d like to work for.",
        p_tech: "Javascript, React, HTML, CSS, React-Router, React-Scroll",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899/portfolio",
        p_web: "https://vars-p.netlify.app/",
    },
    {
        p_id: 4,
        p_name: "NASDAQ chart",
        p_desc:
            "Real-time market data, forward-looking news and insights, trusted analyst research and recommendations, and much more. In addition to real-time stock quotes, you’ll find detailed information on extended trading, indexes, Most Active Stocks, dividend history, ETFs, commodities, cryptocurrencies, and more.",
        p_tech: "Javascript, React, HTML, CSS, API, Chart.js, Moment.js",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899/nasdaq",
        p_web: "https://nasdaq.netlify.app",
    },
    {
        p_id: 5,
        p_name: "Crytocurrency Tracker",
        p_desc:
            "Track crypto prices of over 100 top crypto coins, altcoins & tokens (Bitcoin Cash, Bitcoin Gold, Bitcoin Diamond, Binance Coin, Litecoin, Ethereum Classic, Ripple, Cardano, Monero Classic, Monero Original, ReddCoin, Siacoin, Augur, Zcash, DigiByte, OmiseGO, TenX, MonaCoin, Dogecoin, EOS, MIOTA, XVG, ZRX & many more).",
        p_tech: "Javascript, React, HTML, CSS, API",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899/cryptocurreny-tracker",
        p_web: "https://vars-crypt.netlify.app/",
    },
    {
        p_id: 13,
        p_name: "Weather forecast",
        p_desc:
            "Weather app detects weather forecasts in your current location. There are many information in weather forcasts which includes atmospheric pressure, weather condition, visibility distance, relative humidity, precipitation in different unites, dew point, wind speed and direction, in addition to ten days future forecast, also hourly weather forecast. ",
        p_tech: "Javascript, React, HTML, CSS",
        p_img: "weather_app.jpg",
        p_git: "https://github.com/vars7899",
        p_web: "https://weather-vars.netlify.app",
    },
];
